<!--suppress XmlDuplicatedId -->
<template>
    <div v-if="chapter != null && max_page > 0" id="reader"
         :class="'row flex-column g-0 layout-horizontal' + (hide_sidebar ? ' hide-sidebar' : '') + (isPhone ? ' is-phone' : '')"
         :inert="chapterLoading ? '' : null" :aria-busy="chapterLoading"
         :data-renderer="renderingMode" :data-display="displayFit" :data-direction="direction" :data-custom-zoom="readerZoom !== 100" :style="{'--reader-zoom': readerZoom / 100, '--reader-brightness': readerBrightness / 100}">
        <div id="reader-controls-container" class="container">
            <div id="reader-controls-wrapper" class="bg-reader-controls row g-0 flex-nowrap">
                <div class="d-none d-lg-flex col-auto justify-content-center align-items-center cursor-pointer"
                     id="reader-controls-collapser" data-setting="hide-sidebar" :data-value="hide_sidebar^1"
                     role="button" tabindex="0" :aria-expanded="!hide_sidebar" aria-controls="reader-controls"
                     @click="setSettings" @keydown.enter.prevent="setSettings" @keydown.space.prevent="setSettings">
                    <span class="fas fa-caret-right fa-fw arrow-link" aria-hidden="true" title="Réduire le menu"
                          data-setting="hide-sidebar" :data-value="hide_sidebar^1"></span>
                </div>
                <div id="reader-controls" class="col row g-0 flex-column flex-nowrap">
                    <div id="reader-controls-title" class="col-auto text-center p-2">
                        <router-link :to="comic.url" class="comic-title" :title="comic.title">
                            <span class="fas fa-arrow-left fa-fw" aria-hidden="true"></span>
                            Retour à l’œuvre : {{ comic.title }}
                        </router-link>
                    </div>
                    <div id="reader-controls-chapters" class="col-auto row g-0 align-items-center">
                        <router-link v-if="chapter.previous != null" :title="chapter.previous.full_title"
                                     id="chapter-link-left" class="col-auto arrow-link" :to="chapter.previous.url">
                            <span class="fas fa-angle-left fa-fw" aria-hidden="true"></span>
                        </router-link>
                        <router-link v-else id="chapter-link-left" class="col-auto arrow-link"
                                     title="Retour à l’œuvre" :to="comic.url">
                            <span class="fas fa-angle-left fa-fw" aria-hidden="true"></span>
                        </router-link>
                        <div class="col py-2">
                            <select class="form-control form-select col" id="jump-chapter" name="jump-chapter" @change="jumpChapter">
                                <template v-for="other_ch in comic.chapters">
                                    <option v-if="other_ch.url !== chapter.url" :value="other_ch.url">
                                        {{ (other_ch.full_chapter ? other_ch.full_chapter : other_ch.full_title) + (other_ch.anime_resume ? ' ★' : '') }}
                                    </option>
                                    <option v-else value="" selected>
                                        {{ (chapter.full_chapter ? chapter.full_chapter : chapter.full_title) + (chapter.anime_resume ? ' ★' : '') }}
                                    </option>
                                </template>
                            </select>
                        </div>
                        <router-link v-if="chapter.next != null" :title="chapter.next.full_title"
                                     id="chapter-link-right" class="col-auto arrow-link" :to="chapter.next.url">
                            <span class="fas fa-angle-right fa-fw" aria-hidden="true"></span>
                        </router-link>
                        <router-link v-else id="chapter-link-right" class="col-auto arrow-link"
                                     title="Retour à l’œuvre" :to="comic.url">
                            <span class="fas fa-angle-right fa-fw" aria-hidden="true"></span>
                        </router-link>
                        <div class="col-auto py-2 pe-2 d-lg-none">
                            <select id="jump-page" class="form-control form-select" name="jump-page" @change="jumpPage">
                                <template v-for="(ch_page, index) in chapter.pages">
                                    <option v-if="page !== index+1" :value="index + 1">
                                        {{ index + 1 }}
                                    </option>
                                    <option v-else :value="index + 1" selected>
                                        {{ index + 1 }}
                                    </option>
                                </template>
                            </select>
                        </div>
                    </div>
                    <div id="reader-controls-groups" class="g-0 p-2 text-center fw-bold">
                        <p class="mb-1">{{ chapter.title ? chapter.title : chapter.full_title }}</p>
                        <a v-if="chapter.chapter_download !== null" :href="reader.API_BASE_URL + chapter.chapter_download">
                            <span class="fa fa-download fa-fw" title="Télécharger le chapitre"></span>
                        </a>
                        <span v-else class="fa fa-download fa-fw text-secondary" title="Téléchargement indisponible"></span>
                        <a v-if="chapter.download_link !== null" :href="chapter.download_link" target="_blank">
                            <span class="fa fa-cloud-download-alt fa-fw" title="Téléchargement externe"></span>
                        </a>
                        <span v-else class="fa fa-cloud-download-alt fa-fw text-secondary" title="Téléchargement externe indisponible"></span>
                        <a v-if="chapter.pdf !== null" :href="reader.API_BASE_URL + chapter.pdf">
                            <span class="fa fa-file-pdf fa-fw" title="Télécharger le PDF"></span>
                        </a>
                        <span v-else class="fa fa-file-pdf fa-fw text-secondary" title="PDF indisponible"></span>
                        <a v-if="chapter.id !== null" :href="reader.BASE_URL + 'admin/comics/' + comic.slug + '/chapters/' + chapter.id" target="_blank">
                            <span class="fas fa-edit fa-fw me-0" aria-hidden="true" title="Modifier le chapitre"></span>
                        </a>
                        <div class="mc-rating" v-if="comic">
                            <div class="mc-stars" role="radiogroup" aria-label="Noter ce manga">
                                <button v-for="n in 5" :key="n" type="button" class="mc-star" :class="{ 'is-on': starState(n) !== 'empty' }" @mouseenter="ratingHover = n" @mouseleave="ratingHover = 0" @click="sendRating(n)" :disabled="ratingBusy" :aria-label="'Noter ' + n + ' sur 5'">
                                    <span :class="starIcon(n)"></span>
                                </button>
                            </div>
                            <span class="mc-rating-text">
                                <template v-if="ratingInfo && ratingInfo.average !== null">
                                    <strong>{{ ratingLabel }}</strong><span class="mc-rating-count"> · {{ ratingInfo.count }} vote{{ ratingInfo.count > 1 ? 's' : '' }}</span>
                                </template>
                                <template v-else>Pas encore de note</template>
                                <span v-if="ratingInfo && ratingInfo.your_vote" class="mc-rating-mine"> · Votre note : {{ ratingInfo.your_vote }}/5{{ ratingThanks ? ' — merci !' : '' }}</span>
                                <span v-else class="mc-rating-hint"> · Cliquez pour noter</span>
                            </span>
                        </div>
                    </div>
                    <div id="reader-controls-actions" class="col-auto row g-0 p-1">
                        <div class="col row g-0">
                            <a title="Réglages du lecteur" class="btn btn-secondary col m-1 d-inline d-lg-none" role="button"
                               id="settings-button" :aria-expanded="settingsOpen" aria-controls="reader-controls-mode" :class="{active: settingsOpen}" @click="toggleSettings">
                                <span class="fas fa-cog fa-fw"></span><span class="d-none d-lg-inline"> Réglages</span>
                            </a>
                            <a title="Masquer l’en-tête" class="btn btn-secondary col m-1" role="button" @click="setSettings"
                               id="hide-header-button" :data-value="hide_header^1" data-setting="hide-header">
                                <span class="far fa-window-maximize fa-fw" :data-value="hide_header^1"
                                      data-setting="hide-header"></span>
                                <span class="d-none d-lg-inline" :data-value="hide_header^1"
                                      data-setting="hide-header"> {{ hide_header ? 'Afficher l’en-tête' : 'Masquer l’en-tête' }}</span>
                            </a>
                            <a title="Plein écran" class="btn btn-secondary col m-1" role="button" @click="toggleFullscreen"
                               id="fullscreen-button">
                                <span class="fas fa-fw" :class="fullscreen ? 'fa-compress' : 'fa-expand'" aria-hidden="true"></span>
                                <span class="d-none d-lg-inline"> {{ fullscreen ? 'Quitter le plein écran' : 'Plein écran' }}</span>
                            </a>
                        </div>
                    </div>
                    <div id="reader-controls-mode" class="col-auto d-lg-flex flex-column rs-panel" :class="{'d-none': !settingsOpen}">
                        <div class="rs-heading"><span>Réglages de lecture</span><span class="fas fa-sliders-h" aria-hidden="true"></span></div>
                        <fieldset class="rs-section">
                            <legend>Affichage</legend>
                            <div class="rs-modes">
                                <label v-for="mode in [{value:'single-page',label:'Simple',icon:'fa-file'},{value:'double-page',label:'Double',icon:'fa-book-open'},{value:'long-strip',label:'Webtoon',icon:'fa-scroll'}]" :key="mode.value" class="rs-mode" :class="{'is-selected':renderingMode===mode.value}">
                                    <input type="radio" name="reader-mode" :value="mode.value" :checked="renderingMode===mode.value" :data-value="mode.value" data-setting="renderingMode" @change="setSettings">
                                    <span :class="'fas '+mode.icon" aria-hidden="true"></span><span>{{ mode.label }}</span>
                                </label>
                            </div>
                            <div v-if="renderingMode==='double-page'" class="rs-offset">
                                <label class="rs-switch-row" :class="{'is-disabled':!offsetHasEffect}" for="rs-offset"><span>Décaler les pages</span><input id="rs-offset" type="checkbox" role="switch" :checked="chapterOffset" :disabled="!offsetHasEffect" @change="togglePageOffset"><span class="rs-switch" aria-hidden="true"></span></label>
                                <p>{{ chapterOffset ? 'Association décalée d’une page.' : 'Association normale des pages.' }} Les grandes doubles pages restent seules ; le réglage s’applique aussi aux pages suivantes.</p>
                                <p v-if="!offsetHasEffect" class="rs-hint">{{ offsetHint }}</p>
                            </div>
                        </fieldset>
                        <fieldset class="rs-section reader-zoom-control">
                            <legend>Zoom</legend>
                            <div class="rs-zoom-heading"><label for="reader-zoom-range">Zoom</label><output for="reader-zoom-range" aria-live="polite">{{ readerZoom }} %</output></div>
                            <div class="rs-zoom-track">
                                <button type="button" aria-label="Dézoomer" :disabled="readerZoom<=25" @click="setReaderZoom(readerZoom-5)">−</button>
                                <input id="reader-zoom-range" type="range" min="25" max="200" step="5" :value="readerZoom" :aria-valuetext="readerZoom+' %'" @input="setReaderZoom($event.target.value)">
                                <button type="button" aria-label="Augmenter le zoom" :disabled="readerZoom>=200" @click="setReaderZoom(readerZoom+5)">+</button>
                            </div>
                            <button type="button" class="rs-text-button" :disabled="readerZoom===100" @click="setReaderZoom(100)">Revenir à 100 %</button>
                        </fieldset>
                        <fieldset class="rs-section reader-brightness-control">
                            <legend>Luminosité</legend>
                            <div class="rs-zoom-heading"><label for="reader-brightness-range">Luminosité des pages</label><output for="reader-brightness-range" aria-live="polite">{{ readerBrightness }} %</output></div>
                            <div class="rs-zoom-track">
                                <button type="button" aria-label="Baisser la luminosité" :disabled="readerBrightness<=40" @click="setReaderBrightness(readerBrightness-10)">−</button>
                                <input id="reader-brightness-range" type="range" min="40" max="140" step="5" :value="readerBrightness" :aria-valuetext="readerBrightness+' %'" @input="setReaderBrightness($event.target.value)">
                                <button type="button" aria-label="Augmenter la luminosité" :disabled="readerBrightness>=140" @click="setReaderBrightness(readerBrightness+10)">+</button>
                            </div>
                            <button type="button" class="rs-text-button" :disabled="readerBrightness===100" @click="setReaderBrightness(100)">Revenir à 100 %</button>
                        </fieldset>
                        <fieldset class="rs-section">
                            <legend>Sens de lecture</legend>
                            <p v-if="renderingMode==='long-strip'">De haut en bas</p>
                            <div v-else class="rs-direction">
                                <label v-for="item in [{value:'ltr',label:'Gauche à droite',icon:'fa-arrow-right'},{value:'rtl',label:'Droite à gauche',icon:'fa-arrow-left'}]" :key="item.value" :class="{'is-selected':direction===item.value}">
                                    <input type="radio" name="reader-direction" :value="item.value" :checked="direction===item.value" :data-value="item.value" data-setting="direction" @change="setSettings">
                                    <span :class="'fas '+item.icon" aria-hidden="true"></span><span>{{ item.label }}</span>
                                </label>
                            </div>
                        </fieldset>
                        <button type="button" class="rs-reset" data-setting="reset" data-value="0" @click="setSettings"><span class="fas fa-undo" aria-hidden="true"></span> Réinitialiser les réglages</button>
                    </div>

                    <div id="reader_html" class="text-center d-none d-lg-block"></div>

                    <div id="reader-controls-footer" class="col-auto mt-auto d-none d-lg-flex justify-content-center">
                        <div
                            class="text-muted text-center text-truncate row flex-wrap justify-content-center p-2 g-0">
                            Proposé par&nbsp;
                            <a href="https://discord.gg/cMeCbKuuWy" target="_blank">
                                Manga-Corporation
                            </a>
                        </div>
                    </div>
                    <div id="reader-controls-pages" class="col-auto d-none d-lg-flex row g-0 align-items-center">
                        <router-link :to="pageDestination(valueLeft)" id="page-link-left" class="col-auto arrow-link">
                            <span class="fas fa-angle-left fa-fw" aria-hidden="true" title="Page précédente" @click="needToRefresh = true" id="turn-left"></span>
                        </router-link>
                        <div id="reader-controls-page-text" class="col text-center cursor-pointer">
                            {{ reader.__('Page') }} <span class="current-page">{{ currentSpread.join('–') }}</span> /
                            <span class="total-pages"> {{ max_page }} </span>
                        </div>

                        <router-link :to="pageDestination(valueRight)" id="page-link-right" class="col-auto arrow-link">
                            <span class="fas fa-angle-right fa-fw" aria-hidden="true" title="Page suivante" @click="needToRefresh = true" id="turn-right"></span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div @click="clickPage" id="reader-main" class="col row g-0 flex-column flex-nowrap noselect">
            <noscript>
                <div class="alert alert-danger text-center">
                    JavaScript doit être activé pour utiliser le lecteur.
                </div>
            </noscript>
            <div id="banner_top" class="text-center"></div>
            <div id="reader-images" :rendering="renderingMode" :data-spread-count="renderedPages"
                class="col-auto row g-0 flex-nowrap m-auto text-center cursor-pointer directional">
                <template v-if="renderingMode === 'single-page'">
                    <div :data-page="page" :style="'order: ' + page + ';'" :rendering="renderingMode" :class="'reader-image-wrapper col-auto my-auto justify-content-center align-items-center noselect nodrag row g-0' + (imageFailed[page] ? ' has-error' : '')">
                        <img :key="chapter.pages[page-1]" :src="pageSrc(page)" :alt="'Page ' + page" class="noselect nodrag cursor-pointer" :class="{ 'is-broken': imageFailed[page] }" draggable="false" @load="onPagedImageLoad($event, page)" @error="onImageError($event, page)">
                        <div v-if="imageFailed[page]" class="reader-image-error" role="alert">
                            <span class="fas fa-image" aria-hidden="true"></span>
                            <p>Cette page n’a pas pu se charger.</p>
                            <button type="button" @click.stop="retryImage(page)"><span class="fas fa-rotate-right" aria-hidden="true"></span> Réessayer</button>
                        </div>
                    </div>
                </template>
                <template v-else-if="renderingMode === 'double-page'">
                    <div v-for="number in currentSpread" :key="number" :data-page="number" :style="'order: ' + number + ';'" :rendering="renderingMode" :class="'reader-image-wrapper col-auto my-auto justify-content-center align-items-center noselect nodrag row g-0' + (imageFailed[number] ? ' has-error' : '')">
                        <img :key="chapter.pages[number-1]" :src="pageSrc(number)" :alt="'Page ' + number" class="noselect nodrag cursor-pointer" :class="{ 'is-broken': imageFailed[number] }" draggable="false" @load="onPagedImageLoad($event, number)" @error="onImageError($event, number)">
                        <div v-if="imageFailed[number]" class="reader-image-error" role="alert">
                            <span class="fas fa-image" aria-hidden="true"></span>
                            <p>Cette page n’a pas pu se charger.</p>
                            <button type="button" @click.stop="retryImage(number)"><span class="fas fa-rotate-right" aria-hidden="true"></span> Réessayer</button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div v-for="(ch_page, index) in chapter.pages" :key="ch_page" :data-page="index+1" :style="'order: ' + (index+1) + ';'" :rendering="renderingMode" :class="'reader-image-wrapper col-auto my-auto justify-content-center align-items-center noselect nodrag row g-0' + (imageFailed[index+1] ? ' has-error' : '')">
                        <img :src="pageSrc(index+1)" :alt="'Page ' + (index+1)" :class="{ 'is-broken': imageFailed[index+1] }" draggable="false" @load="onWebtoonImageLoad(index+1)" @error="onImageError($event, index+1)">
                        <div v-if="imageFailed[index+1]" class="reader-image-error" role="alert">
                            <span class="fas fa-image" aria-hidden="true"></span>
                            <p>Cette page n’a pas pu se charger.</p>
                            <button type="button" @click.stop="retryImage(index+1)"><span class="fas fa-rotate-right" aria-hidden="true"></span> Réessayer</button>
                        </div>
                    </div>
                    <div id="webtoon-next">
                        <router-link v-if="chapter.next != null" :to="chapter.next.url" class="wt-next-btn">
                            Chapitre Suivant
                            <span class="fas fa-angle-right" aria-hidden="true"></span>
                        </router-link>
                        <router-link v-else :to="comic.url" class="wt-next-btn">
                            Retour à l’œuvre
                        </router-link>
                    </div>
                </template>
            </div>
            <div id="banner_bottom" class="text-center"></div>
            <div id="reader-page-bar" class="col-auto d-none d-lg-flex directional">
                <div id="track" class="cursor-pointer row g-0">
                    <div id="trail" class="position-absolute h-100 noevents"
                         :style="'width: ' + (page === max_page ? 100*page/max_page : (100*(page+renderedPages-1)/max_page)) + '%;'">
                        <div id="thumb" class="h-100"
                             :style="'width: ' + (page === max_page ? 100/page : (100/(page+renderedPages-1)*renderedPages)) + '%;'"></div>
                    </div>
                    <div id="notches" class="row g-0 h-100 w-100 directional">
                        <template v-for="(ch_page, index) in chapter.pages">
                            <router-link :class="images[index+1] == null ? 'notch col' : 'notch col loaded'"
                                         :data-page="index+1" @mouseover="setNotch(index+1)"
                                         :to="'#' + (index+1)" :style="'order: ' + (index+1) + ';'">
                                <div @click="needToRefresh = true"></div>
                            </router-link>
                        </template>
                    </div>
                    <div id="notch-display" class="col-auto m-auto px-3 py-1 noevents">
                        {{ hover_page }} / {{ max_page }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="max_page > 0" id="reader-page-counter" :key="chapter ? chapter.url : 0" aria-hidden="true">{{ currentSpread.join('–') }}<span>/ {{ max_page }}</span></div>
        <button v-if="max_page > 0 && !commentsOpen" id="comments-fab" type="button" :style="{ top: commentsTop + 'px' }"
                :title="commentsCount ? commentsCount + ' commentaire' + (commentsCount > 1 ? 's' : '') : 'Commentaires'"
                @click="toggleComments">
            <span class="fas fa-comments fa-fw" aria-hidden="true"></span><span v-if="commentsCount" class="cf-count">{{ commentsCount }}</span>
        </button>
        <button v-if="max_page > 0 && !reportOpen" id="report-fab" type="button" :style="{ top: (commentsTop + 46) + 'px' }"
                title="Signaler un problème" aria-label="Signaler un problème de lecture" @click="openReport">
            <span class="fas fa-flag fa-fw" aria-hidden="true"></span>
        </button>
        <div v-if="reportOpen" id="reader-report" role="dialog" aria-modal="true" aria-label="Signaler un problème de lecture">
            <div class="rr-panel">
                <div class="rr-head"><span><span class="fas fa-flag fa-fw" aria-hidden="true"></span> Signaler un problème</span><button type="button" class="rr-close" aria-label="Fermer" @click="closeReport">✕</button></div>
                <p class="rr-context" v-if="chapter">{{ comic.title }} — {{ chapter.full_title || chapter.title }}</p>
                <template v-if="!reportSent">
                    <label class="rr-label" for="rr-page">Page concernée</label>
                    <select id="rr-page" v-model.number="reportPage" class="rr-input">
                        <option :value="0">Le chapitre entier / je ne sais pas</option>
                        <option v-for="n in max_page" :key="n" :value="n">Page {{ n }}{{ n === page ? ' (actuelle)' : '' }}</option>
                    </select>
                    <fieldset class="rr-cats">
                        <legend>Type de problème</legend>
                        <label v-for="cat in reportCategories" :key="cat.value" :class="{'is-selected': reportCategory === cat.value}">
                            <input type="radio" name="rr-category" :value="cat.value" v-model="reportCategory">
                            <span>{{ cat.label }}</span>
                        </label>
                    </fieldset>
                    <template v-if="reportCategory === 'typo'">
                        <label class="rr-label" for="rr-excerpt">Texte mal orthographié (recopiez le mot ou la phrase)</label>
                        <input id="rr-excerpt" v-model="reportTypo" class="rr-input" maxlength="255" placeholder="Ex. : « il menaçait de le tué »">
                    </template>
                    <label class="rr-label" for="rr-comment">{{ reportCategory === 'typo' ? 'Correction proposée (facultatif)' : 'Commentaire (facultatif)' }}</label>
                    <textarea id="rr-comment" v-model="reportText" class="rr-input" rows="3" maxlength="600" :placeholder="reportCategory === 'typo' ? 'Écrivez la correction attendue…' : 'Décrivez brièvement le problème…'"></textarea>
                    <p v-if="reportError" class="rr-error" role="alert">{{ reportError }}</p>
                    <button type="button" class="rr-send" :disabled="reportSending || !reportCategory || (reportCategory === 'typo' && !reportTypo.trim())" @click="sendReport">{{ reportSending ? 'Envoi…' : 'Envoyer le signalement' }}</button>
                </template>
                <template v-else>
                    <p class="rr-success" role="status"><span class="fas fa-circle-check" aria-hidden="true"></span> {{ reportConfirmation }}</p>
                    <button type="button" class="rr-send" @click="closeReport">Fermer</button>
                </template>
            </div>
        </div>
        <div v-if="commentsOpen" id="reader-comments" role="dialog" aria-label="Commentaires">
            <div class="rc-header">
                <span><span class="fas fa-comments fa-fw" aria-hidden="true"></span> Commentaires <span v-if="commentsCount" class="rc-count">{{ commentsCount }}</span></span>
                <button type="button" class="rc-close" aria-label="Fermer" @click="commentsOpen = false">✕</button>
            </div>
            <div ref="commentsBody" class="rc-body">
                <p v-if="commentsLoading" class="rc-empty">Chargement…</p>
                <template v-else>
                    <p v-if="!comments.length" class="rc-empty">Aucun commentaire. Sois le premier !</p>
                    <div v-for="c in comments" :key="c.id" class="rc-item">
                        <div class="rc-meta">
                            <strong>{{ c.nickname }}</strong>
                            <span v-if="c.staff" class="rc-staff">Staff</span>
                            <span class="rc-time">{{ timeAgo(c.created_at) }}</span>
                        </div>
                        <div class="rc-text">{{ c.content }}</div>
                        <button type="button" class="rc-report" :disabled="c.reported" :title="c.reported ? 'Signalé' : 'Signaler'" @click="reportComment(c)">🚩</button>
                    </div>
                </template>
            </div>
            <div class="rc-form">
                <p v-if="loggedInName" class="rc-logged">Connecté en tant que <strong>{{ loggedInName }}</strong></p>
                <input v-else v-model="commentNickname" type="text" maxlength="40" placeholder="Pseudo (optionnel)" class="rc-input">
                <textarea v-model="commentText" maxlength="1500" rows="3" placeholder="Ton commentaire… (reste sympa !)" class="rc-textarea" @keydown.ctrl.enter="sendComment"></textarea>
                <input v-model="commentHoneypot" type="text" name="website" class="rc-honeypot" tabindex="-1" autocomplete="off" aria-hidden="true">
                <div class="rc-actions">
                    <span v-if="commentError" class="rc-error">{{ commentError }}</span>
                    <button type="button" class="rc-send" :disabled="commentSending || commentText.trim().length < 2" @click="sendComment">
                        {{ commentSending ? 'Envoi…' : 'Envoyer' }}
                    </button>
                </div>
                <p class="rc-note">Commentaires publics, modérés a posteriori.</p>
            </div>
        </div>
        <div v-if="accountTip" id="account-tip" role="dialog" aria-label="Créer un compte">
            <div class="at-card">
                <button type="button" class="at-close" aria-label="Fermer" @click="accountTip = false">✕</button>
                <p class="at-title">Garde ta progression, où que tu lises</p>
                <p class="at-sub">Crée ton compte gratuit en 10 secondes :</p>
                <ul class="at-list">
                    <li><span class="fas fa-bookmark fa-fw" aria-hidden="true"></span> Ton <strong>suivi de séries</strong> conservé sur tous tes appareils</li>
                    <li><span class="fas fa-sync fa-fw" aria-hidden="true"></span> Ta <strong>progression de lecture</strong> synchronisée : reprends où tu t'es arrêté</li>
                    <li><span class="fas fa-user-circle fa-fw" aria-hidden="true"></span> Un <strong>profil et une photo</strong> personnalisés</li>
                </ul>
                <div class="at-buttons">
                    <a :href="socialUrl('google')" class="at-btn at-google"><span class="fab fa-google fa-fw" aria-hidden="true"></span> S'inscrire / Se connecter avec Google</a>
                    <a :href="socialUrl('discord')" class="at-btn at-discord"><span class="fab fa-discord fa-fw" aria-hidden="true"></span> S'inscrire / Se connecter avec Discord</a>
                </div>
                <button type="button" class="at-later" @click="accountTip = false">Plus tard</button>
            </div>
        </div>
        <popup :popupData="popupData"></popup>
    </div>
    <div v-else ref="notfound"><popup :popupData="popupData"></popup></div>
</template>

<script>
import Vue from 'vue'
import {buildSpreads, spreadStart, spreadPages, offsetKey, readPageOffset, writePageOffset} from '../manga/spreads';
import {mapGetters} from "vuex";
import NotFound from './NotFound.vue';
import Popup from'./Popup.vue';

export default {
    name: "Read",
    components : { NotFound, Popup },
    mounted() {
        // Detection telephone (meme logique que le header) pour le bouton webtoon en fin de chapitre.
        this.isPhone = !!document.querySelector('#header.mc-phone');
        this.setupParams(this.$route.params)
        $('body').addClass('body-reader');
        $('#nav-search').show();
        $('#nav-filter').hide();
        if (this.hide_header) this.hideHeader();
        this.$store.dispatch('fetchChapter', this.$route.path)
            .then(() => {
                if (this.$store.getters.chapter !== null) {
                    this.max_page = this.$store.getters.chapter.pages.length;
                    this.updateViewChapter();
                    this.setPage(this.$route.hash);
                    this.loadProgress();
                } else {
                    const ComponentClass = Vue.extend(NotFound);
                    const instance = new ComponentClass({
                        propsData: { reader: this.reader }
                    });
                    instance.$mount();
                    if(typeof this.$refs.notfound !== "undefined") this.$refs.notfound.appendChild(instance.$el);
                    const title = 'Error 404' + " | " + this.reader.SITE_NAME;
                    $('title').html(title);
                    $('meta[property="og:title"]').html(title);
                }
            }).finally(() => { this.chapterLoading = false; });
        this.chapter != null && this.updateCustomHTML();
        window.addEventListener('resize', this.layoutDoublePages);
        window.addEventListener('reader-header-resize', this.layoutDoublePages);
        window.addEventListener('reader-scroll-page', this.trackWebtoonPage);
        window.addEventListener('wheel', this.cancelWebtoonJump, {passive:true});
        window.addEventListener('touchstart', this.cancelWebtoonJump, {passive:true});
        window.addEventListener('pointerdown', this.cancelWebtoonJump, {passive:true});
        window.addEventListener('keydown', this.cancelWebtoonJump);
        document.addEventListener('fullscreenchange', this.updateFullscreen);
        document.addEventListener('webkitfullscreenchange', this.updateFullscreen);
        document.addEventListener('msfullscreenchange', this.updateFullscreen);
        this.$nextTick(() => {
            this.spreadObserver = new ResizeObserver(() => this.layoutDoublePages());
            const main = document.getElementById('reader-main');
            if (main) this.spreadObserver.observe(main);
        });
    },
    beforeUnmount() {
        this.imageGeneration++;
        window.removeEventListener('resize', this.layoutDoublePages);
        window.removeEventListener('reader-header-resize', this.layoutDoublePages);
        window.removeEventListener('reader-scroll-page', this.trackWebtoonPage);
        window.removeEventListener('wheel', this.cancelWebtoonJump);
        window.removeEventListener('touchstart', this.cancelWebtoonJump);
        window.removeEventListener('pointerdown', this.cancelWebtoonJump);
        window.removeEventListener('keydown', this.cancelWebtoonJump);
        document.removeEventListener('fullscreenchange', this.updateFullscreen);
        document.removeEventListener('webkitfullscreenchange', this.updateFullscreen);
        document.removeEventListener('msfullscreenchange', this.updateFullscreen);
        if (this.spreadObserver) this.spreadObserver.disconnect();
    },
    beforeRouteUpdate(to, from) {
        if (from.path !== to.path) {
            this.setupParams(to.params)
            this.chapterLoading = true;
            this.imageGeneration++;
            this.images = [];
            this.detectedWidePages = [];
            this.imageFailed = {};
            this.imageAttempts = {};
            this.imageTokens = {};
            this.perfStart = (typeof performance !== 'undefined' ? performance.now() : 0);
            this.perfSent = false;
            this.needToRefresh = true;
            this.$store.dispatch('fetchChapter', to.path)
                .then(() => {
                    if (this.$store.getters.chapter !== null) {
                        this.max_page = this.$store.getters.chapter.pages.length;
                        this.updateViewChapter();
                        this.setPage(to.hash);
                        this.loadProgress();
                    }
                }).finally(() => { this.chapterLoading = false; });
        } else {
            this.animation = true;
            this.setPage(to.hash);
        }
    },
    updated() {
        if (this.needToRefresh) {
            if (this.renderingMode === 'long-strip') {
                // Vue renders every Webtoon image independently of the paged cache.
            } else {
                // Vue owns the visible images; preloading must never replace their DOM.
                this.swipeInit();
            }
            this.scrollTopOfPage();
            this.needToRefresh = false;
        } else if (this.firstLoad && this.page > 1 && this.renderingMode === 'long-strip') {
            this.animation = true;
            this.scrollTopOfPage();
        }
        if(this.firstLoad && this.$store.getters.chapter && this.$store.getters.chapter.licensed) {
            this.showPopup();
        }
        if (this.chapter != null && (this.needToRefresh || this.firstLoad)) {
            this.updateCustomHTML();
        }
        this.firstLoad = false;
        this.$nextTick(this.layoutDoublePages);
    },
    data() {
        return {
            reader: this.$root,
            viewed: this.$root.getSetting('viewed') ? JSON.parse('' + this.$root.getSetting('viewed')) : {},
            readerZoom: Math.min(200, Math.max(25, Number(localStorage.getItem('readerZoom')) || 100)),
            readerBrightness: Math.min(140, Math.max(40, Number(localStorage.getItem('readerBrightness')) || 100)),
            page: 1,
            imageFailed: {},
            imageAttempts: {},
            imageTokens: {},
            perfStart: (typeof performance !== 'undefined' ? performance.now() : 0),
            perfSent: false,
            requestedPage: 1,
            pageRequestRevision: 0,
            progressTimer: null,
            accountTip: false,
            isPhone: false,
            max_page: 0,
            hover_page: 1,
            hide_header: parseInt(this.$root.getSetting('hide-header') || 0),
            fullscreen: false,
            comments: [],
            commentsCount: 0,
            commentsOpen: false,
            commentsLoaded: false,
            commentsLoading: false,
            reportOpen: false,
            reportPage: 0,
            reportCategory: '',
            reportTypo: '',
            reportText: '',
            reportSending: false,
            reportSent: false,
            reportError: '',
            reportConfirmation: '',
            reportCategories: [
                { value: 'missing_image', label: 'Image manquante' },
                { value: 'wrong_order', label: 'Mauvais ordre des pages' },
                { value: 'unreadable', label: 'Image illisible / coupée' },
                { value: 'typo', label: 'Faute d’orthographe' },
                { value: 'other', label: 'Autre problème' },
            ],
            commentNickname: (function () { try { return localStorage.getItem('comment-nickname') || ''; } catch (e) { return ''; } })(),
            commentText: '',
            commentHoneypot: '',
            commentError: '',
            commentSending: false,
            hide_sidebar: parseInt(this.$root.getSetting('hide-sidebar') || 0),
            settingsOpen: false,
            displayFit: 'fit-width',
            renderingMode: this.$root.getSetting('renderingMode') || 'single-page',
            direction: this.$root.getSetting('direction') || 'ltr',
            doublePageOffset: localStorage.getItem('doublePageOffset') === '1',
            offsetOverride: null,
            valueLeft: this.$root.getSetting('direction') === 'rtl' ? 1 : -1,
            valueRight: this.$root.getSetting('direction') === 'rtl' ? -1 : 1,
            animation: false,
            needToRefresh: true,
            images: [],
            detectedWidePages: [],
            imageGeneration: 0,
            chapterLoading: true,
            webtoonJumpPending: false,
            firstLoad: false,
            ratingHover: 0,
            ratingBusy: false,
            ratingThanks: false,
            popupData : {
                "header" : this.$root.__('Chapitre sous licence'),
                "body" : this.$root.__('Ce chapitre est sous licence et ne peut pas être consulté.'),
                "button" : "Fermer",
            }
        }
    },
    methods: {
        trackWebtoonPage(event) {
            if (this.renderingMode !== 'long-strip' || this.webtoonJumpPending) return;
            const page = Number(event.detail);
            if (Number.isInteger(page) && page >= 1 && page <= this.max_page) {
                this.page = page;
                this.requestedPage = page;
                this.pageRequestRevision++;
            }
        },
        cancelWebtoonJump() { this.webtoonJumpPending = false; },
        // URL de la page, avec jeton anti-cache quand une nouvelle tentative est en cours.
        pageSrc(number) {
            const base = this.chapter && this.chapter.pages ? this.chapter.pages[number - 1] : '';
            if (!base) return '';
            const token = this.imageTokens[number];
            if (!token) return base;
            return base + (base.indexOf('?') === -1 ? '?' : '&') + 'retry=' + token;
        },
        // Erreur de chargement : 2 tentatives automatiques limitees, puis etat explicite avec bouton.
        onImageError(event, number) {
            if (event && event.target) event.target.classList.add('is-broken');
            const attempts = (this.imageAttempts[number] || 0) + 1;
            this.imageAttempts[number] = attempts;
            if (attempts <= 2) {
                window.setTimeout(() => { this.imageTokens[number] = Date.now(); }, 700 * attempts);
            } else {
                this.imageFailed[number] = true;
            }
        },
        retryImage(number) {
            this.imageFailed[number] = false;
            this.imageAttempts[number] = 0;
            this.imageTokens[number] = Date.now();
        },
        // Signalement d'un probleme de lecture (discret, depuis les reglages).
        openReport() {
            this.reportOpen = true;
            this.reportSent = false;
            this.reportError = '';
            this.reportText = '';
            this.reportTypo = '';
            this.reportCategory = '';
            this.reportPage = (this.page > 0 && this.page <= this.max_page) ? this.page : 0;
        },
        closeReport() {
            this.reportOpen = false;
        },
        sendReport() {
            if (!this.reportCategory || this.reportSending) return;
            this.reportSending = true;
            this.reportError = '';
            window.axios.post(this.reader.API_BASE_URL + '/reports', {
                path: this.$route.path,
                page: this.reportPage > 0 ? this.reportPage : null,
                category: this.reportCategory,
                excerpt: this.reportCategory === 'typo' ? (this.reportTypo.trim() || null) : null,
                comment: this.reportText.trim() || null,
                website: '',
            }).then((res) => {
                this.reportConfirmation = (res.data && res.data.message) || 'Merci ! Ton signalement a bien été transmis à l’équipe.';
                this.reportSent = true;
            }).catch((error) => {
                const data = error.response && error.response.data ? error.response.data : {};
                this.reportError = data.message || (data.errors ? Object.values(data.errors).flat()[0] : '') || 'Envoi impossible pour le moment. Réessaie plus tard.';
            }).finally(() => { this.reportSending = false; });
        },
        onWebtoonImageLoad(number) {
            if (number === 1) this.reportPerfOnce();
            $('.notch[data-page="' + number + '"]').addClass('loaded');
            if (this.webtoonJumpPending) {
                this.$nextTick(() => {
                    if (!this.webtoonJumpPending || this.renderingMode !== 'long-strip') return;
                    const prior = [...document.querySelectorAll('.reader-image-wrapper')].slice(0,this.page);
                    if (prior.every(wrapper => wrapper.querySelector('img')?.complete)) {
                        const target = document.querySelector('.reader-image-wrapper[data-page="' + this.page + '"]');
                        if (target) target.scrollIntoView({block:'start', behavior:'instant'});
                        this.webtoonJumpPending = false;
                    }
                });
            }
        },
        layoutDoublePages() {
            const container = document.getElementById('reader-images');
            const main = document.getElementById('reader-main');
            if (!container || !main) return;
            if (this.spreadObserver && this.observedSpreadMain !== main) {
                this.spreadObserver.disconnect();
                this.spreadObserver.observe(main);
                this.observedSpreadMain = main;
            }
            if (this.renderingMode === 'long-strip') {
                if (container.dataset.equalHeight) {
                    container.style.removeProperty('width');container.style.removeProperty('height');
                    delete container.dataset.equalHeight;
                    this.images.forEach(img => { if (img) img.removeAttribute('style'); });
                    container.querySelectorAll('.reader-image-wrapper').forEach(wrapper => {
                        ['width', 'height', 'flex'].forEach(property => wrapper.style.removeProperty(property));
                    });
                }
                return;
            }
            const wrappers = [...container.querySelectorAll('.reader-image-wrapper')];
            const images = wrappers.map(wrapper => wrapper.querySelector('img'));
            if (!images.length || images.some(img => !img || !img.naturalWidth || !img.naturalHeight)) return;
            const ratios = images.map(img => img.naturalWidth / img.naturalHeight);
            const totalRatio = ratios.reduce((sum, ratio) => sum + ratio, 0);
            // Reserve a second page's space when the offset leaves a page alone.
            // Only the visible image is drawn, centered at the normal spread scale.
            const soloSpread = this.renderingMode === 'double-page' && images.length === 1;
            // A solo landscape page is the mangaka's double-page: it keeps the full spread width.
            const wideSolo = soloSpread && ratios[0] > 1;
            const companion = soloSpread && !wideSolo ? this.images[this.page === 1 ? 2 : this.page - 1] : null;
            const companionRatio = companion && companion.naturalWidth && companion.naturalHeight
                ? companion.naturalWidth / companion.naturalHeight : ratios[0];
            const sizingRatio = soloSpread && !wideSolo ? totalRatio + companionRatio : totalRatio;
            // Keep the open-menu reading width as the reference in both states.
            const width = Math.max(1, main.clientWidth - (window.innerWidth >= 992 ? window.innerWidth * 0.23 : 0));
            const header = document.body.classList.contains('hide-header') ? 0 : (document.getElementById('header')?.getBoundingClientRect?.().height || parseFloat(getComputedStyle(document.body).fontSize) * 3.5);
            // Reserve the bottom strip (page counter + navigation bar) so pages never collide with them.
            const viewportHeight = Math.max(100, window.innerHeight - header - 58);
            let height = Math.min(width / sizingRatio, viewportHeight);
            if (this.displayFit === 'no-resize') height = Math.max(...images.map(img => img.naturalHeight), companion?.naturalHeight || 0);
            height *= this.readerZoom / 100;
            container.dataset.equalHeight = 'true';
            container.style.setProperty('width', (height * totalRatio) + 'px', 'important');
            container.style.setProperty('height', height + 'px', 'important');
            wrappers.forEach((wrapper, i) => {
                wrapper.style.setProperty('width', (height * ratios[i]) + 'px', 'important');
                wrapper.style.setProperty('height', height + 'px', 'important');
                wrapper.style.setProperty('flex', '0 0 auto', 'important');
                images[i].style.setProperty('width', (height * ratios[i]) + 'px', 'important');
                images[i].style.setProperty('height', height + 'px', 'important');
                images[i].style.setProperty('max-width', 'none', 'important');
                images[i].style.setProperty('max-height', 'none', 'important');
            });
        },
        setReaderZoom(value) {
            const zoom = Number(value);
            if (!Number.isFinite(zoom)) return;
            this.readerZoom = Math.min(200, Math.max(25, Math.round(zoom / 5) * 5));
            localStorage.setItem('readerZoom', String(this.readerZoom));
        },
        togglePageOffset(event) {
            this.offsetOverride = event.target.checked;
            writePageOffset(localStorage, offsetKey(this.comic, this.chapter), this.offsetOverride);
            // Keep the reader's anchor, not the start of the previous pair.
            this.setPage('#' + this.requestedPage);
        },
        pageDestination(step) {
            const number = step > 0 ? this.page + this.renderedPages : this.page - 1;
            if (number >= 1 && number <= this.max_page) return '#' + number;
            const adjacent = step > 0 ? this.chapter.next : this.chapter.previous;
            return adjacent ? adjacent.url + (step < 0 ? '#last' : '') : this.comic.url;
        },
        setupParams(params) {
            if (params.pathMatch) {
                ['vol', 'ch', 'sub'].forEach(element => {
                    let index = params.pathMatch.indexOf(element);
                    if (index !== -1) {
                        params[element] = params.pathMatch[index + 1];
                    }
                });
            }
        },
        setPage(hash) {
            if (this.max_page < 1) return;
            this.pageRequestRevision++;
            if (hash === "#last" || hash === "") this.animation = false;
            let page;
            let requested_page = hash.substring(1);
            if (requested_page === "last" || parseInt(requested_page) > this.max_page) {
                page = this.max_page;
            } else {
                page = isNaN(parseInt(requested_page)) || parseInt(requested_page) < 1 ? 1 : parseInt(requested_page);
            }
            this.requestedPage = page;
            if (this.renderingMode === 'double-page') page = spreadStart(page, this.max_page, this.widePages, this.chapterOffset);
            this.needToRefresh = true;
            this.page = page;
            this.webtoonJumpPending = this.renderingMode === 'long-strip' && page > 1;
            let target_hash = '#' + this.requestedPage;
            if (location.hash !== target_hash) {
                // Normalize the page without adding a history entry that traps Back.
                window.history.replaceState(window.history.state, '', location.pathname + location.search + target_hash);
            }
            if (this.renderingMode !== 'long-strip') this.preloadImagesFrom(page);
        },
        jumpPage(e) {
            this.needToRefresh = true;
            this.setPage('#' + e.target.value);
        },
        // Invitation a creer un compte : 1re fois au 1er chapitre, puis tous les 5 chapitres, 3 fois maximum.
        maybeShowAccountTip() {
            if (typeof LOGGED_IN !== 'undefined' && LOGGED_IN) return;
            if (this.accountTip || !this.max_page || this.page < this.max_page) return;
            let count, last, readCount;
            try {
                // Nombre total de chapitres lus (deja marques comme lus sur le site).
                readCount = 0;
                Object.keys(this.viewed || {}).forEach(slug => {
                    const chapters = this.viewed[slug];
                    if (chapters) readCount += Object.keys(chapters).length;
                });
                // Migration de l'ancien marqueur (deja vu une fois).
                if (localStorage.getItem('mc_account_tip_count') === null && localStorage.getItem('mc_account_tip_seen') === '1') {
                    localStorage.setItem('mc_account_tip_count', '1');
                    localStorage.setItem('mc_account_tip_last', String(readCount));
                }
                count = parseInt(localStorage.getItem('mc_account_tip_count') || '0', 10);
                last = parseInt(localStorage.getItem('mc_account_tip_last') || '-1', 10);
                if (count >= 3) return;
                if (count > 0 && (readCount - last) < 5) return;
                localStorage.setItem('mc_account_tip_count', String(count + 1));
                localStorage.setItem('mc_account_tip_last', String(readCount));
            } catch (e) {
                return;
            }
            setTimeout(() => { this.accountTip = true; }, 700);
        },
        socialUrl(provider) {
            const base = typeof BASE_URL !== 'undefined' ? BASE_URL : '/';
            return base + 'auth/' + provider + '/redirect';
        },
        // Progression de lecture synchronisee (compte connecte).
        queueProgressSave() {
            if (!(typeof LOGGED_IN !== 'undefined' && LOGGED_IN)) return;
            clearTimeout(this.progressTimer);
            this.progressTimer = setTimeout(() => this.saveProgress(), 2500);
        },
        saveProgress() {
            if (!(typeof LOGGED_IN !== 'undefined' && LOGGED_IN)) return;
            const comic = this.$store.getters.comic;
            const chapter = this.$store.getters.chapter;
            if (!comic || !chapter || !comic.slug || !chapter.slug_lang_vol_ch_sub || this.max_page < 1) return;
            const viewed = {};
            viewed[chapter.slug_lang_vol_ch_sub] = 1;
            axios.post(API_BASE_URL + '/reader/progress', {
                slug: comic.slug,
                chapter: chapter.slug_lang_vol_ch_sub,
                page: this.page,
                viewed: viewed,
            }).catch(() => {});
        },
        loadProgress() {
            if (!(typeof LOGGED_IN !== 'undefined' && LOGGED_IN)) return;
            const comic = this.$store.getters.comic;
            const chapter = this.$store.getters.chapter;
            if (!comic || !chapter || !comic.slug || !chapter.slug_lang_vol_ch_sub) return;
            const generation = this.imageGeneration;
            const revision = this.pageRequestRevision;
            axios.get(API_BASE_URL + '/reader/progress/' + encodeURIComponent(comic.slug))
                .then(res => {
                    if (generation !== this.imageGeneration || chapter !== this.chapter) return;
                    const progress = res.data && res.data.progress;
                    if (!progress) return;
                    const viewed = progress.viewed && typeof progress.viewed === 'object' ? progress.viewed : {};
                    if (Object.keys(viewed).length) {
                        if (!this.viewed[comic.slug]) this.viewed[comic.slug] = {};
                        Object.assign(this.viewed[comic.slug], viewed);
                        try { localStorage.setItem('viewed', JSON.stringify(this.viewed)); } catch (e) {}
                    }
                    // Reprendre ou le lecteur s'etait arrete (meme chapitre, sans ancre explicite).
                    const page = parseInt(progress.page) || 0;
                    const hashPage = parseInt((location.hash || '').substring(1));
                    if (revision === this.pageRequestRevision && progress.chapter === chapter.slug_lang_vol_ch_sub && page > 1
                        && (!location.hash || location.hash === '#' || isNaN(hashPage) || hashPage === 1)) {
                        this.setPage('#' + page);
                    }
                })
                .catch(() => {});
        },
        jumpChapter(e) {
            this.needToRefresh = true;
            this.$router.push(e.target.value);
        },
        setNotch(page) {
            this.hover_page = page;
        },
        hideHeader() {
            $('body').toggleClass('hide-header', Boolean(this.hide_header));
        },
        toggleFullscreen() {
            const doc = document;
            const element = doc.documentElement;
            const active = doc.fullscreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement;
            const ignoreRejection = function (promise) { if (promise && promise.catch) promise.catch(function () {}); };
            try {
                if (active) {
                    ignoreRejection((doc.exitFullscreen || doc.webkitExitFullscreen || doc.msExitFullscreen || function () {}).call(doc));
                } else {
                    ignoreRejection((element.requestFullscreen || element.webkitRequestFullscreen || element.msRequestFullscreen || function () {}).call(element));
                }
            } catch (error) {}
        },
        updateFullscreen() {
            const doc = document;
            this.fullscreen = Boolean(doc.fullscreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement);
        },
        toggleComments() {
            this.commentsOpen = !this.commentsOpen;
            if (this.commentsOpen && !this.commentsLoaded) this.loadComments();
        },
        loadComments() {
            if (this.commentsLoading) return;
            this.commentsLoading = true;
            this.commentError = '';
            window.axios.get(this.reader.API_BASE_URL + '/comments' + this.$route.path.slice(5))
                .then((res) => {
                    this.comments = res.data.comments || [];
                    this.commentsCount = res.data.count || this.comments.length;
                    this.commentsLoaded = true;
                })
                .catch(() => { this.commentError = 'Impossible de charger les commentaires.'; })
                .finally(() => { this.commentsLoading = false; });
        },
        sendComment() {
            const content = this.commentText.trim();
            if (content.length < 2 || this.commentSending) return;
            this.commentSending = true;
            this.commentError = '';
            window.axios.post(this.reader.API_BASE_URL + '/comments' + this.$route.path.slice(5), {
                nickname: this.commentNickname.trim(),
                content: content,
                website: this.commentHoneypot,
            }).then((res) => {
                this.comments = res.data.comments || [];
                this.commentsCount = res.data.count || this.comments.length;
                this.commentsLoaded = true;
                this.commentText = '';
                this.commentHoneypot = '';
                try { localStorage.setItem('comment-nickname', this.commentNickname.trim()); } catch (e) {}
                this.$nextTick(() => {
                    const body = this.$refs.commentsBody;
                    if (body) body.scrollTop = body.scrollHeight;
                });
            }).catch((err) => {
                if (err.response && err.response.status === 429) this.commentError = 'Trop de messages, réessaie dans une minute.';
                else if (err.response && err.response.status === 422) this.commentError = 'Message invalide (2 à 1500 caractères).';
                else this.commentError = 'Erreur, réessaie plus tard.';
            }).finally(() => { this.commentSending = false; });
        },
        reportComment(comment) {
            if (comment.reported) return;
            window.axios.post(this.reader.API_BASE_URL + '/comments/report/' + comment.id, {})
                .then(() => { comment.reported = true; })
                .catch(() => {});
        },
        timeAgo(iso) {
            try {
                return window.timePassed ? window.timePassed(new Date(iso)) : '';
            } catch (e) { return ''; }
        },
        hideSidebar() {
            // The root class is bound to hide_sidebar by Vue.
        },
        toggleSettings() {
            this.settingsOpen = !this.settingsOpen;
        },
        setSettings(e) {
            const control = e.currentTarget || e.target;
            const setting = control.dataset.setting;
            const value = control.dataset.value;
            if (setting === 'direction') {
                this.direction = value;
                this.valueLeft = this.direction === 'ltr' ? -1 : 1;
                this.valueRight = this.direction === 'ltr' ? 1 : -1;
            } else if (setting === 'hide-header') {
                this.hide_header = this.hide_header ? 0 : 1;
                this.hideHeader();
            } else if (setting === 'hide-sidebar') {
                this.hide_sidebar = this.hide_sidebar ? 0 : 1;
                this.hideSidebar();
            } else if (setting === 'displayFit') {
                this.displayFit = value;
            } else if (setting === 'renderingMode') {
                this.renderingMode = value;
                this.setPage('#' + this.requestedPage);
                this.needToRefresh = true;
            } else if (setting === 'reset') {
                this.displayFit = 'fit-width';
                const comic = this.$store.getters.comic;
                this.renderingMode = comic.format_id === 2 ? 'long-strip' : 'single-page';
                this.direction = 'ltr';
                this.valueLeft = -1;
                this.valueRight = 1;
                this.needToRefresh = true;
                this.readerZoom = 100;
                localStorage.removeItem('readerZoom');
                localStorage.removeItem('displayFit');
                localStorage.removeItem('renderingMode');
                localStorage.removeItem('direction');
                this.doublePageOffset = false;
                localStorage.removeItem('doublePageOffset');
                this.offsetOverride = null;
                writePageOffset(localStorage, offsetKey(this.comic, this.chapter), null);
                this.setPage('#' + this.requestedPage);
                return;
            } else {
                return;
            }
            localStorage.setItem(setting, setting === 'hide-sidebar' ? this.hide_sidebar : setting === 'hide-header' ? this.hide_header : value);
            //this.reader.setCookie(setting, value, 3650);
        },
        scrollTopOfPage() {
            $('button[data-bs-target="#navbarSupportedContent"][aria-expanded="true"]').click();
            if (this.max_page < 1 || !this.animation) return;
            let offset = $('body').hasClass('hide-header') ? 0 : (document.getElementById('header')?.getBoundingClientRect().height || 0);
            if (this.renderingMode === 'long-strip') {
                const target = document.querySelector('.reader-image-wrapper[data-page="' + this.page + '"]');
                if (target) target.scrollIntoView({block:'start', behavior:'instant'});
            } else {
                $('html,body').scrollTop($('.reader-image-wrapper[data-page="' + this.page + '"]').offset().top - offset);
            }
            this.animation = false;
        },
        recordPageImage(image, number) {
            $('.notch[data-page="' + number + '"]').addClass('loaded');
            if (image.naturalWidth > image.naturalHeight && !this.widePages.has(number)) {
                this.detectedWidePages.push(number);
                if (this.renderingMode === 'double-page') this.setPage('#' + this.requestedPage);
            }
            this.$nextTick(this.layoutDoublePages);
        },
        onPagedImageLoad(event, number) {
            const image = event.target;
            if (!this.chapter || image.getAttribute('src') !== this.chapter.pages[number - 1]) return;
            this.recordPageImage(image, number);
            if (number <= this.currentSpread[0]) this.reportPerfOnce();
        },
        // Mesure legere de l'experience reelle : temps jusqu'a la 1re planche visible + erreurs d'images.
        reportPerfOnce() {
            if (this.perfSent) return;
            this.perfSent = true;
            try {
                const ms = Math.round(performance.now() - this.perfStart);
                const payload = JSON.stringify({ type: 'read', ms, errors: Object.keys(this.imageFailed).length });
                const url = this.reader.API_BASE_URL + '/perf';
                if (navigator.sendBeacon) {
                    navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
                } else {
                    fetch(url, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: payload }).catch(() => {});
                }
            } catch (error) {
                // La mesure ne doit jamais interferer avec la lecture.
            }
        },
        preloadImage(url, i, generation = this.imageGeneration) {
            return new Promise((resolve, reject) => {
                const image = new Image();
                this.images[i] = image;
                image.onload = () => {
                    if (generation === this.imageGeneration && this.chapter && this.chapter.pages[i - 1] === url) {
                        this.recordPageImage(image, i);
                    }
                    resolve(url);
                }
                image.onerror = function () {
                    reject(url)
                }

                image.draggable = "false";
                image.className = "noselect nodrag cursor-pointer";
                image.alt = "Page " + i;
                image.src = url;
            })
        },
        recursivePreload(page_number, generation = this.imageGeneration) {
            if (generation !== this.imageGeneration || page_number > this.max_page || this.renderingMode === 'long-strip') return;
            if (this.images[page_number] == null) {
                this.preloadImage(this.chapter.pages[page_number - 1], page_number, generation)
                    .catch(() => {})
                    .then(() => this.recursivePreload(page_number + 1, generation));
            } else if (this.images[page_number].complete && this.images[page_number].naturalWidth && page_number < this.max_page) {
                this.recursivePreload(page_number + 1, generation);
            }
        },
        async preloadImagesFrom(page_number) {
            if (page_number == null) return;
            this.recursivePreload(page_number);
        },
        clickPage(e){
            if (this.renderingMode === 'long-strip' || e.defaultPrevented || e.button > 0) return;
            // Only the reading surface and its margins turn pages, never controls or banners.
            if (e.target !== e.currentTarget && !e.target.closest('#reader-images')) return;
            if (e.target.closest('a,button,input,select,textarea,[role="button"]')) return;
            const images = document.getElementById('reader-images');
            if (!images || !this.max_page) return;
            const bounds = images.getBoundingClientRect();
            e.clientX < bounds.left + bounds.width / 2 ? $('#turn-left').click() : $('#turn-right').click();
        },
        swipeInit() {
            $(document).ready(function(){
                $('#reader-images').swipe( {
                    swipeLeft: function() {$('#reader-images:not([rendering=long-strip])').length && $('html,body').scrollTop() > 200 && $('#turn-right').click()},
                    swipeRight: function() {$('#reader-images:not([rendering=long-strip])').length && $('html,body').scrollTop() > 200 && $('#turn-left').click()},
                });
            });
        },
        updateViewChapter() {
            const comic = this.$store.getters.comic;
            const chapter = this.$store.getters.chapter;
            if(this.max_page > 0) {
                if(typeof this.viewed[comic.slug] === 'undefined'){
                    this.viewed[comic.slug] = {};
                }
                this.viewed[comic.slug][chapter.slug_lang_vol_ch_sub] = 1;
                localStorage.setItem('viewed', JSON.stringify(this.viewed));
                this.queueProgressSave();
                //this.reader.setCookie('viewed', JSON.stringify(this.viewed), 3650);
            }
            const title = chapter.full_title + " | " + comic.title + " | " + this.reader.SITE_NAME;
            $('title').html(title);
            $('meta[property="og:title"]').html(title);
            this.firstLoad = true;
            if (!this.$root.getSetting('renderingMode') && comic.format_id === 2) {
                this.renderingMode = 'long-strip';
            }
            this.$store.dispatch('fetchRating', comic.slug);
            // Decalage des doubles pages : choix manuel du lecteur pour ce chapitre, sinon suggestion serveur.
            this.offsetOverride = readPageOffset(localStorage, offsetKey(comic, chapter));
            // Commentaires : on repart de zero et on precharge ceux du chapitre.
            this.comments = [];
            this.commentsCount = 0;
            this.commentsLoaded = false;
            this.commentError = '';
            this.loadComments();
            // Lien direct "voir les commentaires" depuis la page du manga.
            if (this.$route.query && this.$route.query.comments) this.commentsOpen = true;
        },
        setReaderBrightness(value) {
            this.readerBrightness = Math.min(140, Math.max(40, Number(value) || 100));
            localStorage.setItem('readerBrightness', this.readerBrightness);
        },
        starState(n) {
            const info = this.ratingInfo;
            const value = this.ratingHover > 0 ? this.ratingHover : (info && info.your_vote ? info.your_vote : (info && info.average ? info.average : 0));
            if (n <= Math.floor(value)) return 'full';
            if (n === Math.ceil(value) && value % 1 >= 0.25) return 'half';
            return 'empty';
        },
        starIcon(n) {
            const state = this.starState(n);
            return state === 'full' ? 'fas fa-star' : (state === 'half' ? 'fas fa-star-half-stroke' : 'far fa-star');
        },
        sendRating(n) {
            const slug = this.comic ? this.comic.slug : null;
            if (!slug || this.ratingBusy) return;
            this.ratingBusy = true;
            this.$store.dispatch('sendRating', {slug: slug, vote: n})
                .then(() => {
                    this.ratingThanks = true;
                    setTimeout(() => { this.ratingThanks = false; }, 5000);
                })
                .catch(() => {})
                .finally(() => { this.ratingBusy = false; });
        },
        showPopup() {
            const modal = new bootstrap.Modal(document.getElementById('modal-container'));
            modal.show();
        },
        updateCustomHTML() {
            this.reader.updateCustomHTML('banner_top');
            this.reader.updateCustomHTML('banner_bottom');
            this.reader.updateCustomHTML('reader_html');
        },
    },
    watch: {
        // Sauvegarde la position de lecture (compte connecte) sans spammer l'API.
        page() {
            this.queueProgressSave();
            this.maybeShowAccountTip();
        },
        max_page() {
            this.maybeShowAccountTip();
        },
    },
    computed: {
        // Nom du compte connecte : les commentaires sont alors signes automatiquement.
        loggedInName() {
            return typeof AUTH_USER_NAME !== 'undefined' && AUTH_USER_NAME ? AUTH_USER_NAME : null;
        },
        // Landscape files are the mangaka's own double-pages. The server flags
        // stored pages; images without flags (external) are detected once loaded.
        widePages() {
            const set = new Set();
            const flags = (this.chapter && this.chapter.pages_landscape) || [];
            flags.forEach((flag, index) => { if (Number(flag)) set.add(index + 1); });
            this.detectedWidePages.forEach(number => set.add(number));
            return set;
        },
        currentSpread() { return this.renderingMode === 'double-page' ? spreadPages(this.page, this.max_page, this.widePages, this.chapterOffset) : [this.page]; },
        chapterOffset() {
            if (this.offsetOverride !== null) return this.offsetOverride;
            if (this.chapter && this.chapter.suggested_offset) return true;
            return this.doublePageOffset;
        },
        offsetHasEffect() {
            if (this.renderingMode !== 'double-page' || !this.max_page) return true;
            const sans = JSON.stringify(buildSpreads(this.max_page, this.widePages, false));
            const avec = JSON.stringify(buildSpreads(this.max_page, this.widePages, true));
            return sans !== avec;
        },
        offsetHint() {
            if (this.max_page < 2) return 'Chapitre d’une seule page : il n’y a rien à apparier.';
            return 'Ce chapitre ne contient pas de pages simples consécutives à décaler.';
        },
        renderedPages() { return this.currentSpread.length || 1; },
        commentsTop() {
            void this.hide_header;
            if (this.hide_header) return 12;
            const header = document.getElementById('header');
            const height = header ? header.getBoundingClientRect().height : 0;
            return Math.round((height || parseFloat(getComputedStyle(document.body).fontSize) * 3.5) + 10);
        },
        ratingInfo() {
            return this.$store.getters.rating(this.comic ? this.comic.slug : null);
        },
        ratingLabel() {
            const info = this.ratingInfo;
            if (!info || info.average === null || info.average === undefined) return '';
            const value = Number(info.average);
            return (Number.isInteger(value) ? String(value) : value.toFixed(1).replace('.', ',')) + '/5';
        },
        ...mapGetters([
            'comic',
            'chapter',
            'vote_token'
        ])
    }
}
</script>

<style>
/* Luminosite : filtre applique aux pages uniquement, les controles gardent leur aspect. */
#reader #reader-images{filter:brightness(var(--reader-brightness,1))}
#reader .rs-offset .rs-hint{margin-top:6px;font-size:12px;opacity:.75}
#reader[data-renderer="double-page"] #reader-images{gap:0;justify-content:center;align-items:center;width:100%}
#reader[data-renderer="double-page"] .reader-image-wrapper{padding:0!important;min-width:0;flex:0 1 50%}
#reader[data-renderer="double-page"] #reader-images[data-spread-count="1"] .reader-image-wrapper{flex-basis:100%;width:100%}
#reader[data-renderer="double-page"] .reader-image-wrapper img{object-fit:contain;object-position:right center}
#reader[data-renderer="double-page"] .reader-image-wrapper:last-child img{object-position:left center}
#reader[data-renderer="double-page"][data-direction="rtl"] .reader-image-wrapper img{object-position:left center}
#reader[data-renderer="double-page"][data-direction="rtl"] .reader-image-wrapper:last-child img{object-position:right center}
#reader[data-renderer="double-page"] #reader-images[data-spread-count="1"] img{object-position:center}
#reader[data-renderer="double-page"][data-display="fit-both"] #reader-images img{width:100%;height:100%;max-height:100%;max-width:100%}
#reader[data-renderer="double-page"][data-display="fit-both"] .reader-image-wrapper{height:100%}
/* Zoom applies to the pages only; controls retain their normal size. */
#reader[data-custom-zoom="true"] #reader-images{width:calc(100% * var(--reader-zoom))!important;max-width:100%;min-width:0;flex-shrink:0}
#reader[data-custom-zoom="true"][data-renderer="long-strip"] .reader-image-wrapper{width:100%;max-width:100%}
#reader[data-custom-zoom="true"][data-renderer="long-strip"] #reader-images img{max-width:100%;height:auto}
#reader[data-custom-zoom="true"][data-display="fit-height"]:not([data-renderer="long-strip"]) #reader-images,
#reader[data-custom-zoom="true"][data-display="fit-both"]:not([data-renderer="long-strip"]) #reader-images{height:calc((100vh - 3.5rem - 15px) * var(--reader-zoom))!important}
body.hide-header #reader[data-custom-zoom="true"][data-display="fit-height"]:not([data-renderer="long-strip"]) #reader-images,
body.hide-header #reader[data-custom-zoom="true"][data-display="fit-both"]:not([data-renderer="long-strip"]) #reader-images{height:calc((100vh - 15px) * var(--reader-zoom))!important}
#reader .reader-zoom-control .form-range{min-width:0;width:100%}
#reader[data-renderer="double-page"] #reader-images[data-equal-height]{max-width:none!important;max-height:none!important;gap:0!important}
#reader[data-renderer="double-page"] #reader-images[data-equal-height] .reader-image-wrapper{max-width:none!important;max-height:none!important;margin-top:0!important;margin-bottom:0!important}
#reader-controls-mode .btn-group label{white-space:normal;font-size:12px;display:flex;align-items:center;justify-content:center}
#reader[data-renderer="single-page"] #reader-images[data-equal-height]{max-width:none!important;max-height:none!important;min-width:0;flex:0 0 auto;justify-content:center}
#reader[data-renderer="single-page"] #reader-images[data-equal-height] .reader-image-wrapper{max-width:none!important;max-height:none!important;padding:0!important;margin:0!important}
#reader[data-renderer="single-page"] #reader-images[data-equal-height] img{object-fit:contain;object-position:center}
#reader #reader-controls-mode.rs-panel{padding:18px 16px;gap:0;width:100%;color:inherit}
#reader .rs-heading{display:flex;align-items:center;justify-content:space-between;font-size:14px;font-weight:700;padding:0 0 18px;gap:10px}
#reader .rs-heading .fas{opacity:.5;font-size:13px}
#reader .rs-section{border:0;border-top:1px solid #8883;margin:0;padding:18px 0;min-width:0;width:100%}
#reader .rs-section legend{float:none;width:auto;margin:0;padding:0 0 12px;font-size:11px;line-height:1.3;font-weight:700;letter-spacing:.6px;color:inherit;opacity:.65}
#reader .rs-modes{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px}
#reader .rs-mode,#reader .rs-direction label{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:9px;border:1px solid #8883;border-radius:7px;margin:0;padding:12px 3px;background:#88808;color:inherit;cursor:pointer;line-height:1.2;font-size:11px;transition:background .15s,border-color .15s}
#reader .rs-mode>.fas{font-size:16px;opacity:.75}
#reader .rs-mode.is-selected,#reader .rs-direction .is-selected{background:#8f7beb1c;border-color:#9c8cda;color:inherit;box-shadow:inset 0 0 0 1px #9c8cda33}
#reader .rs-mode:hover,#reader .rs-direction label:hover{background:#8882}
#reader .rs-mode input,#reader .rs-direction input{position:absolute;opacity:0;width:1px;height:1px}
#reader .rs-mode:focus-within,#reader .rs-direction label:focus-within{outline:2px solid #9c8cda;outline-offset:2px}
#reader .rs-offset{padding-top:16px}#reader .rs-switch-row{display:flex;align-items:center;gap:10px;font-size:12px;margin:0;cursor:pointer;position:relative}#reader .rs-switch-row>span:first-child{flex:1}#reader .rs-switch-row.is-disabled{cursor:default;opacity:.55}
#reader .rs-switch-row input{position:absolute;right:0;opacity:0;width:34px;height:20px}
#reader .rs-switch{width:34px;height:20px;border-radius:20px;background:#8885;border:1px solid #8883;position:relative;flex-shrink:0}
#reader .rs-switch::after{content:'';position:absolute;left:3px;top:3px;width:12px;height:12px;background:#fff;border-radius:50%;box-shadow:0 1px 3px #0003;transition:transform .15s}
#reader .rs-switch-row input:checked+.rs-switch{background:#8170c3}#reader .rs-switch-row input:checked+.rs-switch::after{transform:translateX(14px)}#reader .rs-switch-row input:focus-visible+.rs-switch{outline:2px solid #9c8cda;outline-offset:3px}
#reader .rs-offset p{font-size:10px;opacity:.6;line-height:1.5;margin:8px 0 0}
#reader .rs-zoom-heading{display:flex;justify-content:space-between;align-items:center;font-size:12px;margin-bottom:12px}#reader .rs-zoom-heading output{font-variant-numeric:tabular-nums;border:1px solid #8883;border-radius:5px;padding:3px 8px;font-size:11px}
/* Invitation a creer un compte (invites, fin du premier chapitre). */
#reader #account-tip{position:fixed;left:50%;bottom:18px;transform:translateX(-50%);z-index:1080;width:min(460px,calc(100vw - 24px));animation:at-in .25s ease}
#reader .at-card{position:relative;background:#1d1e27;color:#f2f1f8;border:1px solid #30313f;border-radius:14px;padding:18px 18px 14px;box-shadow:0 18px 50px #0006}
#reader .at-close{position:absolute;top:8px;right:10px;border:0;background:transparent;color:inherit;opacity:.6;font-size:14px;cursor:pointer}
#reader .at-close:hover{opacity:1}
#reader .at-title{font-weight:800;font-size:17px;margin:0 0 4px}
#reader .at-sub{font-size:13px;opacity:.75;margin:0 0 10px}
#reader .at-list{list-style:none;margin:0 0 14px;padding:0;display:flex;flex-direction:column;gap:7px;font-size:13.5px;line-height:1.45}
#reader .at-list .fas{width:18px;color:#9c8cda}
#reader .at-buttons{display:flex;flex-direction:column;gap:8px}
#reader .at-btn{display:flex;align-items:center;justify-content:center;gap:8px;padding:10px 12px;border-radius:9px;font-weight:700;font-size:13.5px;text-decoration:none;color:#fff}
#reader .at-btn:hover{color:#fff;filter:brightness(1.08)}
#reader .at-google{background:#7054d9}
#reader .at-discord{background:#5865F2}
#reader .at-later{display:block;margin:10px auto 0;border:0;background:transparent;color:inherit;opacity:.7;font-size:12.5px;cursor:pointer;text-decoration:underline}
#reader .at-later:hover{opacity:1}
@keyframes at-in{from{opacity:0;transform:translate(-50%,10px)}to{opacity:1;transform:translate(-50%,0)}}
/* Mode webtoon : bouton "Chapitre suivant" en fin de chapitre, sur toutes les plateformes. */
#reader #webtoon-next{display:none;order:9999}
#reader[data-renderer="long-strip"] #webtoon-next{display:flex;justify-content:center;align-items:center;padding:26px 16px 60px}
#reader[data-renderer="long-strip"] .wt-next-btn{display:inline-flex;align-items:center;gap:10px;background:#7054d9;color:#fff!important;text-decoration:none;padding:13px 24px;border-radius:10px;font-weight:800;font-size:15px;box-shadow:0 10px 26px #0006}
@media(max-width:767.98px){
    #reader[data-renderer="long-strip"] #webtoon-next{padding-bottom:110px}
}
#reader .wt-next-btn:hover{background:#5f45c6;color:#fff}
#reader .rs-zoom-track{display:flex;align-items:center;gap:12px}#reader .rs-zoom-track input{accent-color:#9c8cda;flex:1;width:0;min-width:0;cursor:pointer;height:20px}
#reader .rs-zoom-track button{border:1px solid #8883;border-radius:6px;background:#8881;color:inherit;width:28px;height:28px;flex-shrink:0;line-height:1;padding:0;font-size:19px;cursor:pointer}
#reader .rs-text-button{display:block;margin:10px 0 0 auto;border:0;background:none;color:inherit;opacity:.65;font-size:10px;padding:4px 0;cursor:pointer}
#reader .rs-direction{display:grid;grid-template-columns:1fr 1fr;gap:6px}#reader .rs-direction label{font-size:10px;padding:10px 5px;gap:7px}
#reader .rs-reset{border:1px solid #8883;border-radius:7px;background:transparent;color:inherit;font-size:11px;padding:10px 6px;cursor:pointer;width:100%;margin-top:2px}#reader .rs-reset .fas{margin-right:7px;opacity:.6}
#reader .rs-panel button:hover:not(:disabled){background:#8882}#reader .rs-panel button:disabled{opacity:.3;cursor:default}#reader .rs-panel button:focus-visible{outline:2px solid #9c8cda;outline-offset:3px}
@media(prefers-reduced-motion:reduce){#reader .rs-panel *{transition:none!important}}
/* Etat d'erreur d'une image (chargement impossible) + nouvelle tentative. */
#reader .reader-image-wrapper { position: relative; }
#reader .reader-image-error { position: absolute; inset: 0; z-index: 3; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; padding: 18px; background: #101116e8; color: #eceaf6; text-align: center; }
#reader .reader-image-error .fas { font-size: 26px; opacity: .75; }
#reader .reader-image-error p { margin: 0; font-size: 14px; line-height: 1.5; }
#reader .reader-image-error button { border: 0; border-radius: 9px; padding: 10px 18px; background: #7054d9; color: #fff; font-weight: 700; font-size: 14px; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; }
#reader .reader-image-error button:hover { filter: brightness(1.08); }
#reader .reader-image-wrapper img.is-broken { visibility: hidden; }
/* Bouton discret "Signaler un problème" + fenêtre dediee. */
#report-fab{position:fixed;right:calc(23vw + 18px);z-index:6;display:flex;align-items:center;justify-content:center;width:38px;height:38px;padding:0;border-radius:50%;border:1px solid rgba(255,255,255,.28);background:rgba(0,0,0,.72);color:#fff;font-size:14px;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.35);transition:right 240ms cubic-bezier(.22,.61,.36,1),background .15s}
#report-fab:hover{background:rgba(129,112,195,.92)}
#reader.hide-sidebar #report-fab{right:48px}
#reader-report{position:fixed;inset:0;z-index:1085;display:flex;align-items:center;justify-content:center;background:#0b0c10d9;padding:16px}
#reader-report .rr-panel{width:min(480px,100%);max-height:90vh;overflow-y:auto;background:var(--mc-surface,#fff);color:var(--mc-ink,#22232e);border-radius:14px;padding:18px;box-shadow:0 24px 60px #0007}
body.dark #reader-report .rr-panel{background:#1d1e27;color:#f2f1f8}
#reader-report .rr-head{display:flex;align-items:center;justify-content:space-between;font-weight:800;font-size:15px;margin-bottom:8px}
#reader-report .rr-close{border:0;background:transparent;color:inherit;font-size:16px;cursor:pointer;padding:6px}
#reader-report .rr-context{font-size:12.5px;opacity:.75;margin:0 0 10px}
#reader-report .rr-label{display:block;font-size:12px;font-weight:700;margin:10px 0 4px}
#reader-report .rr-input{width:100%;border:1px solid #8884;border-radius:8px;background:transparent;color:inherit;padding:9px 10px;font-size:14px}
#reader-report .rr-cats{border:0;padding:0;margin:10px 0 0}
#reader-report .rr-cats legend{font-size:12px;font-weight:700;margin-bottom:4px}
#reader-report .rr-cats label{display:flex;align-items:center;gap:8px;padding:8px 10px;border:1px solid #8884;border-radius:8px;margin-bottom:6px;cursor:pointer;font-size:13.5px}
#reader-report .rr-cats label.is-selected{border-color:#7054d9;box-shadow:0 0 0 2px #7054d933}
#reader-report .rr-error{color:#e5484d;font-size:13px;margin:8px 0 0}
#reader-report .rr-success{display:flex;align-items:center;gap:8px;color:#2f9e63;font-size:14px;margin:6px 0 12px}
#reader-report .rr-send{width:100%;border:0;border-radius:9px;padding:12px;background:#7054d9;color:#fff;font-weight:800;font-size:14px;cursor:pointer;margin-top:12px}
#reader-report .rr-send:hover:not(:disabled){filter:brightness(1.08)}
#reader-report .rr-send:disabled{opacity:.5;cursor:default}
@media(max-width:991px){#report-fab{right:14px}}
#reader[data-renderer="long-strip"] .reader-image-wrapper.has-error { min-height: 45vh; }
/* Webtoon ignores paged fitting constraints and keeps a continuous strip. */
#reader[data-renderer="long-strip"] #reader-main{height:auto!important;max-height:none!important;min-height:0}
#reader[data-renderer="long-strip"] #reader-images{display:flex!important;flex-direction:column!important;align-items:stretch;gap:0!important;height:auto!important;max-height:none!important;min-width:0!important;width:calc(100% * var(--reader-zoom,1))!important}
#reader[data-renderer="long-strip"] .reader-image-wrapper{display:block!important;flex:0 0 auto!important;width:100%!important;height:auto!important;max-height:none!important;padding:0!important;margin:0!important;scroll-margin-top:60px}
#reader[data-renderer="long-strip"] #reader-images img{display:block!important;width:100%!important;max-width:100%!important;height:auto!important;max-height:none!important;margin:0!important;object-fit:contain;cursor:default}
body.hide-header #reader[data-renderer="long-strip"] .reader-image-wrapper{scroll-margin-top:0}
/* Reserve the menu outside the image: its padding must never scale the pages. */
@media(min-width:992px){
    #reader.layout-horizontal[data-renderer] #reader-main{padding-right:23vw!important;box-sizing:border-box}
    #reader.layout-horizontal.hide-sidebar[data-renderer] #reader-main{padding-right:34px!important}
    #reader.layout-horizontal[data-renderer] #reader-images,
    #reader.layout-horizontal.hide-sidebar[data-renderer] #reader-images{padding-right:0!important}
    #reader.layout-horizontal[data-renderer="long-strip"] #reader-images{width:calc(77vw * var(--reader-zoom,1))!important}
}
/* Keep the controls at their full width while the sidebar slides closed. */
@media(min-width:992px){
    #reader.layout-horizontal #reader-controls-wrapper{overflow:hidden;transition:width 240ms cubic-bezier(.22,.61,.36,1)}
    #reader.layout-horizontal #reader-controls-collapser{flex:0 0 34px}
    #reader.layout-horizontal #reader-controls{flex:0 0 calc(23vw - 34px);min-width:0;transition:opacity 180ms ease,transform 240ms cubic-bezier(.22,.61,.36,1)}
    #reader.layout-horizontal.hide-sidebar #reader-controls{opacity:0;transform:translateX(12px);pointer-events:none;visibility:hidden;transition:opacity 180ms ease,transform 240ms cubic-bezier(.22,.61,.36,1),visibility 0s 240ms}
    #reader.layout-horizontal #reader-main{transition:padding-right 240ms cubic-bezier(.22,.61,.36,1)}
    #reader.layout-horizontal #reader-page-bar{transition:right 240ms cubic-bezier(.22,.61,.36,1)}
}
@media(max-width:991.98px){
    #reader-controls-mode:not(.d-none){animation:reader-settings-open 200ms ease-out}
}
@keyframes reader-settings-open{from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:translateY(0)}}
@media(prefers-reduced-motion:reduce){
    #reader #reader-controls-wrapper,#reader #reader-controls,#reader #reader-main,#reader #reader-page-bar,#reader #reader-controls-mode,#reader #reader-controls-collapser span,#reader #reader-page-counter{transition:none!important;animation:none!important}
}
/* Compteur de page : fixe en bas a droite, au-dessus de la barre de navigation.
   Il monte avec une petite animation a l'ouverture du chapitre et glisse quand le menu se replie. */
#reader{position:relative}
#reader-page-counter{position:fixed;right:calc(23vw + 18px);bottom:34px;z-index:6;width:auto;max-width:none;display:flex;align-items:baseline;padding:3px 11px;border-radius:999px;background:rgba(0,0,0,.72);border:1px solid rgba(255,255,255,.28);box-shadow:0 2px 8px rgba(0,0,0,.45);color:#fff;font-size:13px;font-weight:700;line-height:1.5;font-variant-numeric:tabular-nums;pointer-events:none;user-select:none;text-shadow:0 1px 2px rgba(0,0,0,.6);transition:right 240ms cubic-bezier(.22,.61,.36,1),transform 260ms cubic-bezier(.22,.61,.36,1);animation:reader-counter-rise 420ms cubic-bezier(.22,.61,.36,1)}
/* Quand la petite barre se deploie (survol), le compteur monte avec elle. */
#reader:has(#reader-page-bar:hover) #reader-page-counter{transform:translateY(-26px)}
#reader-page-counter span{font-weight:600;opacity:.72;margin-left:2px}
#reader.hide-sidebar #reader-page-counter{right:48px}
@media(max-width:991px){#reader-page-counter{right:12px;bottom:22px}}
@keyframes reader-counter-rise{from{transform:translateY(20px);opacity:0}to{transform:translateY(0);opacity:1}}
/* Bouton commentaires : flottant en haut a droite du lecteur. */
#comments-fab{position:fixed;right:calc(23vw + 18px);z-index:6;width:auto;max-width:none;display:flex;align-items:center;gap:6px;padding:7px 13px;border-radius:999px;border:1px solid rgba(255,255,255,.28);background:rgba(0,0,0,.72);color:#fff;font-size:14px;font-weight:700;line-height:1;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.35);transition:right 240ms cubic-bezier(.22,.61,.36,1),background .15s,transform .15s;animation:comments-fab-in 320ms cubic-bezier(.22,.61,.36,1)}
#comments-fab:hover{background:rgba(129,112,195,.92);transform:translateY(1px)}
#comments-fab .cf-count{font-size:12px;background:#8170c3;border-radius:999px;padding:2px 7px;min-width:20px;text-align:center}
#reader.hide-sidebar #comments-fab{right:48px}
@media(max-width:991px){#comments-fab{right:12px}}
@keyframes comments-fab-in{from{transform:translateY(-14px);opacity:0}to{transform:translateY(0);opacity:1}}
@media(prefers-reduced-motion:reduce){#comments-fab{animation:none;transition:none}}
/* Panneau de commentaires (tiroir a droite) */
#reader-comments{position:fixed;top:0;right:0;bottom:0;width:min(420px,100%);z-index:1040;display:flex;flex-direction:column;background:var(--bs-body-bg);color:var(--bs-body-color);border-left:1px solid var(--bs-border-color);box-shadow:-8px 0 24px rgba(0,0,0,.25);animation:reader-comments-in 250ms cubic-bezier(.22,.61,.36,1)}
@keyframes reader-comments-in{from{transform:translateX(40px);opacity:0}to{transform:translateX(0);opacity:1}}
#reader-comments .rc-header{display:flex;justify-content:space-between;align-items:center;gap:10px;padding:12px 14px;border-bottom:1px solid var(--bs-border-color);font-weight:700}
#reader-comments .rc-count{background:#8170c3;color:#fff;border-radius:999px;font-size:11px;font-weight:700;padding:1px 8px;margin-left:4px}
#reader-comments .rc-close{border:0;background:none;color:inherit;font-size:16px;cursor:pointer;padding:2px 8px;border-radius:6px}
#reader-comments .rc-close:hover{background:rgba(128,128,128,.18)}
#reader-comments .rc-body{flex:1;overflow-y:auto;padding:10px 14px;display:flex;flex-direction:column;gap:10px}
#reader-comments .rc-empty{opacity:.6;text-align:center;margin:22px 0;font-size:13px}
#reader-comments .rc-item{border:1px solid var(--bs-border-color);border-radius:10px;padding:8px 10px 10px;position:relative}
#reader-comments .rc-meta{display:flex;align-items:center;gap:6px;font-size:12px;margin-bottom:4px}
#reader-comments .rc-staff{background:#2e7d32;color:#fff;border-radius:999px;font-size:10px;font-weight:700;padding:1px 7px}
#reader-comments .rc-time{opacity:.55;margin-left:auto}
#reader-comments .rc-text{white-space:pre-wrap;overflow-wrap:anywhere;font-size:13.5px;line-height:1.5}
#reader-comments .rc-report{position:absolute;right:6px;bottom:4px;border:0;background:none;opacity:.3;cursor:pointer;font-size:12px;padding:2px 4px}
#reader-comments .rc-report:hover{opacity:.9}
#reader-comments .rc-report:disabled{opacity:.7;cursor:default}
#reader-comments .rc-form{border-top:1px solid var(--bs-border-color);padding:10px 14px;display:flex;flex-direction:column;gap:8px}
#reader-comments .rc-input,#reader-comments .rc-textarea{border:1px solid var(--bs-border-color);border-radius:8px;background:transparent;color:inherit;padding:7px 9px;font-size:13px;width:100%;resize:vertical;font-family:inherit}
#reader-comments .rc-logged{margin:0 0 8px;font-size:12.5px;opacity:.85}
#reader-comments .rc-input:focus,#reader-comments .rc-textarea:focus{outline:2px solid #9c8cda;outline-offset:1px}
#reader-comments .rc-honeypot{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}
#reader-comments .rc-actions{display:flex;align-items:center;justify-content:space-between;gap:8px}
#reader-comments .rc-error{color:#d9534f;font-size:12px}
#reader-comments .rc-send{border:0;border-radius:8px;background:#8170c3;color:#fff;font-weight:700;font-size:13px;padding:7px 18px;cursor:pointer;margin-left:auto}
#reader-comments .rc-send:disabled{opacity:.5;cursor:default}
#reader-comments .rc-note{margin:0;font-size:10px;opacity:.55}
@media(prefers-reduced-motion:reduce){#reader-comments{animation:none}}
</style>
